import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22cf456e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "更多直播", -1 /* HOISTED */))
const _hoisted_2 = [
  _hoisted_1
]

import {download} from 'common/util';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "live-more",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(download) && _unref(download)(...args)))
  }, _hoisted_2))
}
}

})